"use strict";
/**
 * @module Services.TopicNotifications
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var conversation_id_serialiser_1 = require("./../../conversation/conversation-id-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
var topic_selector_serialiser_1 = require("./../../topics/topic-selector-serialiser");
/**
 * Serialiser for {@link TopicNotificationSelection}
 */
var TopicNotificationSelectionSerialiserClass = /** @class */ (function (_super) {
    __extends(TopicNotificationSelectionSerialiserClass, _super);
    function TopicNotificationSelectionSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link TopicNotificationSelection} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link TopicNotificationSelection} to be written
     */
    TopicNotificationSelectionSerialiserClass.prototype.write = function (bos, value) {
        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
        topic_selector_serialiser_1.TopicSelectorSerialiser.write(bos, value.selector);
    };
    return TopicNotificationSelectionSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.TopicNotificationSelectionSerialiserClass = TopicNotificationSelectionSerialiserClass;
/**
 * The {@link TopicNotificationSelectionSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.TopicNotificationSelectionSerialiser = new TopicNotificationSelectionSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-notifications/topic-notification-selection-serialiser.js
// module id = 2012
// module chunks = 1